<template>
  <section>
    <div class="filter-articles">
      <button
        class="filter-articles__button"
        @click="tabClicked(1)"
        v-bind:class="[ activetab === 1 ? 'active' : '' ]"
      >
        <span v-if="contentText">Our Customers</span>
        <span v-else>What We Make, Makes us Who We are</span>
      </button>
      <button
        class="filter-articles__button"
        v-on:click="tabClicked(2)"
        v-bind:class="[ activetab === 2 ? 'active' : '' ]"
      >
        <span v-if="contentText">Our Colleagues</span>
        <span v-else>CLIC Sargent with Morrisons</span>
      </button>
      <button
        class="filter-articles__button"
        v-on:click="tabClicked(3)"
        v-bind:class="[ activetab === 3 ? 'active' : '' ]"
      >
        <span v-if="contentText">Our Suppliers</span>
        <span v-else>Morrisingers on tour</span>
      </button>
      <button
        class="filter-articles__button"
        v-on:click="tabClicked(4)"
        v-bind:class="[ activetab === 4 ? 'active' : '' ]"
      >
        <span v-if="contentText">Our Shareholders</span>
        <span v-else>24 Hours in Farming 2018</span>
      </button>
    </div>
    <div v-if="contentText" class="filter-articles__content">
      <div v-if="activetab === 1">
        <TextProse>
          <ul>
            <li>
              An improving shopping trip
              informed by listening
            </li>
            <li>
              More customers, buying more
              from us, more often
            </li>
            <li>
              Customers can get what they
              want, when they want it
            </li>
          </ul>
        </TextProse>
        <BaseButton href="#" variant="primary">Read More</BaseButton>
      </div>
      <div v-if="activetab === 2">
        <TextProse>
          <ul>
            <li>Engaged and motivated colleagues</li>
            <li>Colleagues sharing in the success of the business</li>
            <li>A fair day’s pay for the work they do</li>
          </ul>
        </TextProse>
        <BaseButton href="#" variant="primary">Read More</BaseButton>
      </div>
      <div v-if="activetab === 3">
        <TextProse>
          <ul>
            <li>Establishing lasting relationships</li>
            <li>Working together with simplified terms</li>
            <li>Ways of working that comply with the Groceries Supply Code of Practice</li>
          </ul>
        </TextProse>
        <BaseButton href="#" variant="primary">Read More</BaseButton>
      </div>
      <div v-if="activetab === 4">
        <TextProse>
          <ul>
            <li>A strong balance sheet</li>
            <li>A cash generative business, with low levels of debt</li>
            <li>Sales, profit and dividend growth</li>
          </ul>
        </TextProse>
        <BaseButton href="#" variant="primary">Read More</BaseButton>
      </div>
    </div>
  </section>
</template>

<script>
import BaseButton from '../elements/BaseButton.vue'
export default {
  name: 'TheFilterArticles',
  components: { BaseButton },
  data: function() {
    return {
      activetab: 1
    }
  },
  props: {
    contentText: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    tabClicked(tab) {
      this.activetab = tab
      this.$emit('tabClicked', tab)
    }
  }
}
</script>

<style lang="postcss">
.filter-articles {
  @apply border border-t-0 border-l-0 border-r-0 border-body-light relative w-full flex overflow-x-scroll scrolling-touch mb-8;
}
.filter-articles a {
  @apply block border p-4 cursor-pointer;
}
.filter-articles__button {
  @apply block font-semibold whitespace-no-wrap pb-4 mr-4 border-4 border-t-0 border-l-0 border-r-0 border-transparent;
  position: relative;
}
.filter-articles__button span {
  @apply px-0;
}
.filter-articles__button.active {
  @apply border-secondary text-secondary;
}
.filter-articles__button:hover {
  @apply text-secondary;
}
.filter-articles__button:focus {
  @apply outline-none;
}
.filter-articles__button:first-child {
  @apply ml-6;
}
.filter-articles__button:last-child {
  @apply pr-6;
}
.filter-articles__content {
  @apply w-full px-6;
}
.filter-articles__content ul {
  @apply mb-6;
}
.filter-articles__content li {
  @apply mb-2 ml-4;
  list-style-type: disc;
}
@screen md {
  .filter-articles {
    @apply mb-10;
  }
  .filter-articles__button {
    @apply mr-8;
  }
  .filter-articles__button:first-child {
    @apply ml-0;
  }
  .filter-articles__button:last-child {
    @apply pr-0;
  }
  .filter-articles__content {
    @apply px-0;
  }
}
@screen xl {
  .filter-articles {
    @apply overflow-hidden;
  }
}
</style>